var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 74,
    viewBox: "0 0 99 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8343 0H79.6955L73.0266 16.5595H23.1654L29.8343 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6139 19.1469H71.9737L65.355 35.7064H15.9952L22.6139 19.1469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 38.2938H14.9288L7.7218 54.8533H91.793L99 38.2938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20703 57.4405H91.2782L84.0712 74H0L7.20703 57.4405Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.48c0c47b387726f58eb66edebd398eec.svg";
export { ForwardRef as ReactComponent };